import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  header: string;
  subheader?: string;
}

export const OnboardingScreenHeader: FunctionComponent<IProps> = ({ header, subheader }) => {
  return (
    <View style={styles.container}>
      <Text style={[styles.header]}>
        {header}
      </Text>
      {subheader &&
        <Text style={styles.subheader}>
          {subheader}
        </Text>
      }
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: defaultScale(24),
  },
  header: {
    ...Theme.textStyle.heading,
    marginBottom: defaultScale(6),
  },
  subheader: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_MEDIUM,
  },
});
